import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import LoginForm from "@/components/accounts/LoginForm";
import Link from "next/link";
import Image from "next/image";
import logoImg from "@/public/logo-no-text.svg";

export default function CreateAccountPage() {
  return (
    <>
      <Head>
        {generateNextSeo({
          title: "Log In",
          description:
            "Log in to your Uptime Monitor account to manage your website monitoring, view uptime reports, and configure alerts.",
          canonical: "https://uptime-monitor.io/accounts/login",
          noindex: true,
          nofollow: true,
        })}
      </Head>

      <div className="flex min-h-screen">
        {/* Left side - Login form */}
        <div className="flex w-full flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div className="text-center">
              <Link href="/" className="inline-flex items-center gap-2 text-foreground">
                <Image
                  width={40}
                  height={40}
                  className="h-10 w-10"
                  src={logoImg}
                  alt="Uptime Monitor"
                  priority
                />
                <span className="text-xl font-semibold">Uptime Monitor</span>
              </Link>
              <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-foreground">
                Sign in to your account
              </h2>
              <p className="mt-2 text-sm leading-6 text-muted-foreground">
                Monitor your websites and services with confidence
              </p>
            </div>

            <div className="mt-8 rounded-lg border bg-card px-6 py-8 shadow-sm">
              <LoginForm />
            </div>

            <p className="mt-8 text-center text-xs text-muted-foreground">
              By signing in, you agree to our{" "}
              <Link href="/tos" className="underline underline-offset-4 hover:text-primary">
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link
                href="/privacy_policy"
                className="underline underline-offset-4 hover:text-primary"
              >
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>

        {/* Right side - Image/Pattern */}
        <div className="relative hidden w-0 flex-1 lg:block">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-primary/5" />
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEiIG9wYWNpdHk9IjAuMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIgLz48L3N2Zz4=')] text-muted-foreground/20" />
        </div>
      </div>
    </>
  );
}
